import OBTPageContainer, { withOBTPageContainer } from './OBTPageContainer'
import OnlineManual from './OnlineManual';

export default OBTPageContainer;
export { withOBTPageContainer, OnlineManual };